import { render } from "./LoginOnly.vue?vue&type=template&id=7a65cea5"
import script from "./LoginOnly.vue?vue&type=script&lang=js"
export * from "./LoginOnly.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__